import { ref, computed } from "vue";
import axios from "axios";

// Module-level state: the side navbar, the Suggestions page and the Orders banner
// all read the same summary, and a markSeen() on the page clears the nav badge.
const summary = ref(null);
const lastSeenRunId = ref(null);
let timer = null;
const REFRESH_MS = 5 * 60 * 1000;
const key = (siteId) => `nf_suggestions_lastSeenRun_${siteId}`;

export default function useSuggestionsSummary(store) {
  const apiUrl = store.state.apiUrl;
  const siteId = () => store.state.currentSite;

  const readSeen = () => {
    try {
      lastSeenRunId.value = localStorage.getItem(key(siteId()));
    } catch (e) {
      lastSeenRunId.value = null;
    }
  };

  const refresh = async () => {
    if (!siteId()) return;
    try {
      const { data } = await axios.get(`${apiUrl}/suggestions/summary`, { params: { site: siteId() } });
      summary.value = data;
      readSeen();
    } catch (error) {
      console.error("Error fetching suggestions summary:", error);
    }
  };

  const markSeen = () => {
    const runId = summary.value && summary.value.latestRunId;
    if (!runId) return;
    try {
      localStorage.setItem(key(siteId()), runId);
    } catch (e) {
      // storage unavailable (private mode) — badge simply stays until reload
    }
    lastSeenRunId.value = runId;
  };

  const start = () => {
    refresh();
    if (!timer) timer = setInterval(refresh, REFRESH_MS);
  };

  const badgeCount = computed(() => {
    const s = summary.value;
    if (!s || !s.openCount || !s.latestRunId) return 0;
    return s.latestRunId === lastSeenRunId.value ? 0 : s.openCount;
  });

  return { summary, badgeCount, refresh, markSeen, start };
}
